import { render } from "./AdultCertification.vue?vue&type=template&id=aa0eadb6&scoped=true"
import script from "./AdultCertification.vue?vue&type=script&lang=js"
export * from "./AdultCertification.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=aa0eadb6&scoped=true&lang=css"
import "@/assets/css/user/pages/payment.css?vue&type=style&index=1&id=aa0eadb6&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=aa0eadb6&scoped=true&lang=css"
import "@/assets/css/user/dark/payment-dark.css?vue&type=style&index=3&id=aa0eadb6&scoped=true&lang=css"
import "./AdultCertification.vue?vue&type=style&index=4&id=aa0eadb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0eadb6"]])

export default __exports__